import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as selector from '../../selectors';
import pluralize from 'common/helpers/pluralize';

const mapStateToProps = state => {
	return {
		count: selector.getAppOnline(state),
	};
};

@connect(mapStateToProps)
export default class extends Component {
	static propTypes = {
		count: PropTypes.number,
	}

	render() {
		const {count} = this.props;

		if (count <= 0)
			return null;

		return (
			<div className="online">
				<span className="number">{count}</span>
				<span className="text">
					{pluralize(count,'человек','человека','человек')} сейчас {count > 1 ? 'бронируют':'бронирует'} онлайн
				</span>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/widgets/Online.js